import type React from 'react'
import styled from 'styled-components'

import { EMPTY_VALUE_PLACEHOLDER } from '@constants'

import { Typography } from '../Typography'

const Wrapper = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
`

const LabelTerm = styled.dt`
  margin: 0;
`

const ValueBox = styled.dd`
  width: 100%;
  margin: 0;
  min-height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.field.disabledBorder};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.field.disabledBackground};
  padding: 6px 10px;
`

const LabelText = styled(Typography)`
  color: ${({ theme }) => theme.colors.field.label};
`

const ValueText = styled(Typography)`
  color: ${({ theme }) => theme.colors.field.disabledValue};
`

interface ReadOnlyFieldProps {
  label: StringOrMessage
  value?: React.ReactNode | null
  className?: string
}

export function ReadOnlyField({ label, value, className }: ReadOnlyFieldProps) {
  const isEmpty = value === null || value === undefined || value === ''

  return (
    <Wrapper className={className}>
      <LabelTerm>
        <LabelText tag="span" size="400-sm">
          {label}
        </LabelText>
      </LabelTerm>
      <ValueBox>
        <ValueText tag="p" size="400-md">
          {isEmpty ? EMPTY_VALUE_PLACEHOLDER : value}
        </ValueText>
      </ValueBox>
    </Wrapper>
  )
}
